import Header from '../../components/Header';
import './Login.css';
import DynamicForm from '../../components/dynamicForm';
import { useNavigate } from 'react-router-dom'
import { forgotPassword } from '../../formData/forgotPassword';

export default function ForgotPassword() {
    const navigate = useNavigate()

    const handleAction = (action, data) => {


        console.log('ACTION:', action, 'DATA:', data);
        if (action === 'next') {
            navigate('/signup/step-2')
        }
    };

    return (
        <div className="signup-page">
            <Header />
            <div className="login-content">
                <main className="login-main">
                    <div className='centered-alight-login-comp'>
                        <div className='back-to-login' onClick={() => navigate('/login')}>
                            <span class="material-symbols-outlined">arrow_back</span> 
                            <span>Back to Login</span>
                        </div>
                        <div className='formTitle'>Forget Passowrd</div>
                        <p className="signup-desc">
                            Can’t remember your password? Enter your email below to get password reset instructions.
                        </p>

                        <DynamicForm schema={forgotPassword} onAction={handleAction} />

                        <p className="login-prompt">
                            Don’t have an account? <a href="/">Sign up</a>
                        </p>
                    </div>
                </main>
            </div>
        </div>
    );
}
